import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Label from "./label";
import PlayOverlay from './play-overlay';
import { Link } from "react-router-dom";
import createMarkUp from '@medscape-promo/medscapetv/utils/create-markup';



function Content(props) {
    let { title, thumbnail, watched, playing, jobCode } = props;
    const posterStyle = {
        backgroundImage: `url(${thumbnail})`
    }

    return (
        <div className="content-container ifi">
            <div className="flex-content">
                <div className="image-container" style={ posterStyle }>
                    <Label watched={watched} playing={playing} />
                    <PlayOverlay />
                </div>
            </div>
            <div className="meta-data">
                <div className="header">
                    <span>Information From Industry</span>
                </div>
                <div className="title">
                    <span dangerouslySetInnerHTML={createMarkUp(title)}></span>
                </div>
            <div className="job-code">
                <span dangerouslySetInnerHTML={createMarkUp(jobCode)}></span>
            </div>
            </div>
        </div>
    )
}

Content.propTypes = {
    "title": PropTypes.string,
    "thumbnail": PropTypes.string,
    jobCode: PropTypes.string,
    watched: PropTypes.bool,
    playing: PropTypes.bool
}

Content.defaultProps = {
    "title": "",
    "thumbnail": "",
    jobCode: "",
    watched: false,
    playing: false
}

class IfiItem extends Component {
    constructor(props) {
        super(props);
        //console.log("[IfiItem] props:", props);
        this.linkRef = React.createRef();
    }

    handleClick(e) {
        this.props.onClick(this.linkRef.current)
        //window.wmdPageLink('mtv-intlink',e.currentTarget);
    }
    render() {
        let { href, type, disableRouting, playlistLink, watched, playing } = this.props;

        if (type == 'link') {
            if (playlistLink != null && playlistLink.href != null && playlistLink.href.trim().length > 0) {
                playlistLink.className = cx({
                    "external-link": true,
                })
                playlistLink.onClick = this.handleTracking.bind(this)
                return (
                    <div className="playlist-item external-link" >
                    <a {...playlistLink} ref={this.linkRef} className="video-item">
                        <Content {...this.props} />
                    </a>
                </div>
                )
            } else {
                return null;
            }
        } else {

            const className = cx({
                "watched": watched,
                "playing": playing,
                "video-item": true
            })
            let itemProps = {
                className,
                to: href,
                onClick: this.handleClick.bind(this),
                ref: this.linkRef

            }
            if (disableRouting === true) {
                const linkProps = {
                    href,
                    ref: this.linkRef,
                    onClick: this.handleClick.bind(this),
                    className,
                    target: "_blank",
                    rel: "noreferrer"
                }
                return (
                    <div className="playlist-item" >
                        <a {...linkProps}><Content {...this.props} /></a>
                    </div>
                )
            } else if (!playing) {
                return (
                    <div className="playlist-item" >
                        <Link {...itemProps} >
                            <Content {...this.props} />
                        </Link>
                     </div>
                );
            } else {
                return (
                    <div className="playlist-item" >
                        <div {...itemProps}>
                            <Content {...this.props} />
                        </div>
                    </div>
                )
            }
        }
    }


    static get propTypes() {
        return {
            disableRouting: PropTypes.bool,
            href: PropTypes.string,
            type: PropTypes.string,
            playlistLink: PropTypes.object,
            watched: PropTypes.bool,
            playing: PropTypes.bool,
            "onClick": PropTypes.func,
            "title": PropTypes.string,
            "thumbnail": PropTypes.string,
            "jobCode": PropTypes.string,
        }
    }

    static get defaultProps() {
        return {
            disableRouting: false,
            href: "",
            type: "",
            playlistLink: {},
            watched: false,
            playing: false,
            "onClick": () => {},
            "title": "",
            "thumbnail": "",
            "jobCode": ""
        }
    }
}



export default IfiItem